export enum TaskStatus {
    BACKLOG = 'Yet to Start',
    IN_PROGRESS = 'InProgress',
    OVERDUE = 'Overdue',
    COMPLETED = 'Completed'
  }
  
  export enum TaskType {
    STORY = 'Story',
    TASK = 'Task',
    BUG = 'Bug'
  }
  
  export enum TaskPriority {
    LOW = 'Low',
    MEDIUM = 'Medium',
    HIGH = 'High',
    URGENT = 'Urgent'
  }